export enum ActivationType {
    CRM = 'CRM',
    MEDIA = 'DIG',
}